import logo from './logo.svg';
import './App.css';
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate
} from "react-router-dom";
import './css/style.css'
import Login from './Login';
import 'bootstrap/dist/css/bootstrap.min.css';
import Dashboard from './Dashboard';
import Listing from './Listing';
import Upload from './Upload/Upload';
import Archived from './Components/Archived/Archived';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './css/style.css';
import Grouped from './Grouped/Grouped';
import Sou from './sou/sou';
import ClassCreated from './classCreated/classCreated';
import { useState } from 'react';
import SouDetail from './SouDetail/SouDetail';
import ViewClass from './ViewClass/ViewClass';
import CreateClass from './CreateClass/CreateClass';
import Pending from './Pending/Pending';
import SouDetailExport from './SouDetail/SouDetailsExport';
import Holiday from './holiday/Holiday';
import Training from './training/Training';
import TrainingDetail from './training/TrainingDetail';
import ProtectedRoute from './ProtectedRoute';
import Pagenotfound from './Pagenotfound/Pagenotfound';


function App() {
  const token = window.localStorage.getItem("access_token");
  const isLoggedIn = !!token;
  // console.log(isLoggedIn,"isLoggedIn....");


  return (
    <>
      <ToastContainer position="top-center" autoClose={3000} />
      <Routes>
        <Route path="/" element={isLoggedIn ? <Listing /> : <Login />} />
        <Route path="/sou/:id" element={<SouDetail />} />
        <Route path='/souDetail/:id' element={<SouDetailExport />} />
        <Route element={<ProtectedRoute />}>
          <Route path="/dashboard" element={<Listing />} />
          <Route path="/archived" element={<Archived />} />
          <Route path="/upload" element={<Upload />} />
          <Route path="/grouped" element={<Grouped />} />
          <Route path="/sou" element={<Sou />} />
          <Route path="/class-created" element={<ClassCreated />} />
          <Route path="/create-class" element={<CreateClass />} />
          <Route path="/view-class" element={<ViewClass />} />
          <Route path="/instructor-pending/:id" element={<Pending />} />
          <Route path='/holiday' element={<Holiday />} />
          <Route path="/training" element={<Training />} />
          <Route path="/training/:id" element={<TrainingDetail />} />
        </Route>
        <Route path="*" element={<Pagenotfound />} />
      </Routes>

    </>
  );
}

export default App;
